export const toSentenceCase = (str) => {
    return str.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function (c) {
        return c.toUpperCase();
    });
}
export const getDateFormat = (currentDate) => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add 1 to month because months are 0-based
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${day}/${month}/${year}`
}